import { EnumProductTypes } from "../../../types/listing";
import { SEARCH_LISTING_QUERY_KEY } from "../../../constants/cache";

export const generateSearchListingsQueryKey = (params: {
  bedrooms?: string[];
  bathrooms?: string[];
  acreage?: string[];
  squareFootage?: string[];
  yearBuilt?: string[];
  propertyType?: string[];
  favorite?: boolean | null| undefined;
  tag?: string;
  note?: string;
  companyOwned?: boolean | null| undefined;
  showHidden?: boolean | null| undefined;
  onlyHidden?: boolean | null| undefined;
  listId?: string[];
  currentPage?: number;
  pageSize?: number;
  queryType?: string;
}) => {
  const {
    bedrooms,
    bathrooms,
    acreage,
    squareFootage,
    yearBuilt,
    propertyType,
    tag = "",
    note = "",
    favorite = undefined,
    companyOwned = undefined,
    showHidden = undefined,
    onlyHidden = undefined,
    listId = [],
    currentPage,
    pageSize,
    queryType,
  } = params;
  
  const baseKey = [
    SEARCH_LISTING_QUERY_KEY,
    EnumProductTypes.ns,
    queryType,
    {
      bedrooms,
      bathrooms,
      acreage,
      squareFootage,
      yearBuilt,
      propertyType,
      favorite,
      tag,
      note,
      companyOwned,
      showHidden,
      onlyHidden,
      listId,
      currentPage,
      pageSize,
    },
  ];
  
  return queryType ? baseKey : baseKey.slice(0, -1).concat(baseKey[baseKey.length - 1]);
};